// store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const authUserSlice = createSlice({
  name: "authUserSlice",
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      state.authUser = action.payload;
    },

    updateProductsLog: (state, action) => {
      if (state.authUser) {
        state.authUser.store.last_products_loaded = action.payload;
      }
    },
    resetAuth: (state) => {
      state.email = "";
      state.password = "";
    },
  },
});

export const { setAuthUser, resetAuth, updateProductsLog } = authUserSlice.actions;
export default authUserSlice.reducer;
